export default __webpack_public_path__ + "static/media/cell-type-barcode.676e2750.svg";